module.exports = __webpack_public_path__ + "img/home_news.501d592a.png";